import React from 'react';
import { useTranslation } from '../../../shared/i18n';
import * as S from '../Conecta2ProductPage.styles';
import { getHowToPlaySteps } from '../constants/productDataI18n';
import { YouTubeEmbed } from '../../../shared/components';

const HowToPlaySection = () => {
  const t = useTranslation();
  const stepsTexts = getHowToPlaySteps(t);
  const steps = stepsTexts.map((text, index) => ({
    number: String(index + 1),
    text,
  }));

  return (
    <S.Section $background="#f8f9fa">
      <S.Container>
        <S.SectionTitle>{t('conecta2Product.howToPlay.title')}</S.SectionTitle>
        <S.StepsList>
          {steps.map((step) => (
            <S.StepItem key={step.number}>
              <S.StepNumber>{step.number}</S.StepNumber>
              <S.StepContent>
                <S.StepTitle>{step.text}</S.StepTitle>
              </S.StepContent>
            </S.StepItem>
          ))}
        </S.StepsList>

        <YouTubeEmbed videoId='jnfOw9GP4Xg' title='Presentación Conecta2' />
      </S.Container>
    </S.Section>
  );
};

export default HowToPlaySection;
